import { CeilingHeightContainer } from '../../containers/advancedFilters/CeilingHeightContainer';
import { IFilter } from '../../types/advancedFilters';

export const ceilingHeight: IFilter = {
  component: CeilingHeightContainer,
};
